<script setup>
  import {computed, ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import {router, usePage} from "@inertiajs/vue3";

  defineOptions({
    name: "ComponentAccountInfoSupportCodeDialog",
  });

  const pageProperties = usePage().props;
  const refDialog = ref(null);

  const allThirdParties = ref([]);

  function open() {
    router.reload({
      only: ["allThirdParties", "supportCode"],
      onSuccess: (page) => {
        allThirdParties.value = page.props.allThirdParties?.data ?? [];
      },
    });
    refDialog.value.open();
  }

  const license = computed(() => {
    return pageProperties?.client?.license?.product_name + " " + pageProperties?.client?.license?.version_name;
  });

  const p4uThirdParties = computed(() => {
    return allThirdParties.value
      .filter((thirdParty) => {
        return thirdParty.type === "p4u";
      })
      .map((thirdParty) => {
        return thirdParty.tp_id;
      });
  });

  const nidentThirdParties = computed(() => {
    return allThirdParties.value
      .filter((thirdParty) => {
        return thirdParty.type === "nident";
      })
      .map((thirdParty) => {
        return thirdParty.tp_id + (thirdParty.provider ? " (" + thirdParty.provider + ")" : "");
      });
  });

  const isConnected = computed(() => {
    return allThirdParties.value.length > 1;
  });

  defineExpose({
    open,
  });
</script>

<template>
  <ComponentDialog
    ref="refDialog"
    dialog-type="information"
    dialog-title="Accountinformationen"
    dialog-width="medium"
    :test-id="getTestId('account-information')"
  >
    <template #content>
      <dl>
        <dt class="mt-4 text-xl font-semibold">Aktueller Lizenztyp</dt>
        <dd class="leading-5">
          {{ $page.props.can.is_education ? "MediCheck Education" : license }}
        </dd>

        <template v-if="p4uThirdParties.length > 0">
          <dt class="mt-4 text-xl font-semibold">Kundennummer (pharma4u)</dt>
          <dd class="leading-5">{{ p4uThirdParties.join(", ") }}</dd>
        </template>

        <template v-if="nidentThirdParties.length > 0">
          <dt class="mt-4 text-xl font-semibold">N-Ident</dt>
          <dd class="leading-5">{{ nidentThirdParties.join(", ") }}</dd>
        </template>

        <dt class="mt-4 text-xl font-semibold">Status der Verknüpfung</dt>
        <dd class="leading-5">
          {{
            isConnected
              ? "Die obigen pharma4u- bzw. n-Ident-Zugänge sind miteinander verknüpft und nutzen ein gemeinsames Datenschutzpasswort sowie eine gemeinsame Patientenübersicht"
              : "keine aktive Verknüpfung vorhanden"
          }}
        </dd>

        <dt class="mt-4 text-xl font-semibold">Authentifizierung</dt>
        <dd class="leading-5">
          Eingeloggt über
          {{ $page.props.can.has_p4u_token ? "pharma4u Login" : "Drittsystem (z.B. Warenwirtschaft)" }}
        </dd>

        <dt class="mt-4 text-xl font-semibold">Support-PIN</dt>
        <dd class="leading-5">
          <div class="tracking-widest">{{ $page.props.supportCode }}</div>
        </dd>
      </dl>
    </template>
  </ComponentDialog>
</template>
